import { Grid } from "@mui/material";
import { primaryColor, secondaryColor } from "../../../../../../utils/colors";
import { formatString, getValueOrDefault } from "../../../../../../utils/constants";
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';

import formStyles from "../../../../../../assets/styles/componentStyles/templateLibraryStyles/modifyWhatsAppTemplate/whatsAppTemplateForm.module.scss";
import textstyles from "./../../../../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss";
import styles from './../../../../../../assets/styles/componentStyles/templates.module.scss' 
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import { isWhatsAppIntegration } from "../../../../../../pages/ruleBasedInbox/utils";

export const maxFooterChars = 60;
export const maxChars = 1024;
export const maxHeaderTextChars = 60;
export const maxCarouselHeaderText = 160; 

export const CAROUSEL_MAX_CHARS = {
    HEADER_TEXT: 1024,
    BODY_TEXT: 160,
};

export const maxButtonTextForList = 20;

export const defaultButtonTextForListType = "Select Option";

export const VARIABLE_REGEX = {
    FLAG_NAME: /{{[^}]+}}/g,
    FLAG_NUMBER: /{{\d+}}/g
}

export const BODY_VARIABLE_AT_EDGE_REGEX = {
    FLAG_NAME: {
        START: /^{{[^}]+}}/,
        END: /{{[^}]+}}$/
    },
    FLAG_NUMBER: {
        START: /^{{\d+}}/,
        END: /{{\d+}}$/
    }
}

export const VALIDATE_VARIABLE_REGEX = {
    FLAG_NAME: /^[a-z_]+$/,
    FLAG_NUMBER: /^\d+$/
}

export const getVariableRegex = (flagNamedParam) => {
    if(flagNamedParam){
        return VARIABLE_REGEX['FLAG_NAME'];
    } else {
        return VARIABLE_REGEX['FLAG_NUMBER'];
    }
}
export function extractUniqueVariables(inputString, flagNamedParams) {
    if (!inputString) {
        return []
    }
    const regex = getVariableRegex(flagNamedParams)
    const uniqueVariables = new Set(inputString.match(regex))
    return Array.from(uniqueVariables)
}

export const checkErrorFromWord = (word, flagNamedParams) => {
    if (word && word.trim().length > 0) {
        let uniqueVariable = extractUniqueVariables(word, flagNamedParams)
        if (!(word.trim().split(/\s+/).filter((st) => st != '').length >= 3 * uniqueVariable.length + 1)) {
            return true;
        }
        return false
    }
}

export function displayTemplateType(option) {
    if (option?.whatsapp_template_flag_interactive_message) {
        return `Interactive`
    }
    else {
        return `${option?.whatsapp_template_type?.name} - ${option?.whatsapp_template_data?.[0]?.whatsapp_template_category_name}`
    }
}

export function templateTypeColor(option) {
    if (option?.whatsapp_template_flag_interactive_message) {
        return {
            backgroundColor: secondaryColor,
            color: primaryColor
        }
    }
    else {
        switch (option?.whatsapp_template_type?.name?.toLowerCase()) {
            case TEMPLATE_TYPES['BASIC']?.toLowerCase():
                return {
                    backgroundColor: "rgba(0, 255, 0, 0.1)",
                    color: "green"
                }
            case TEMPLATE_TYPES['CAROUSEL']?.toLowerCase():
                return {
                    backgroundColor: "#c7fcf7",
                    color: "black"
                }
            case TEMPLATE_TYPES['CATALOG']?.toLowerCase():
                return {
                    backgroundColor: "#E6D9F8",
                    color: "#5B3FA3"
                }
            default:
                return {
                    backgroundColor: "rgba(255, 0, 0, 0.1)",
                    color: "red"
                }
        }
    }
}

export const renderTemplateCategoryChip = (option, flagWidthAuto) => {
    return (
        <span
            style={{
                backgroundColor: templateTypeColor(option)?.backgroundColor,
                color: templateTypeColor(option)?.color,
                flexShrink: 0,
            }}
            className={`${textstyles.templateTypeStyle} ${flagWidthAuto ? textstyles.templateTypeStyleWidthAuto : textstyles.templateTypeStyleMinWidth}`}
        >
            {displayTemplateType(option)}
        </span>
    );
}

export function renderTemplateOptions(props, option, key, style) {
    // if (option.whatsapp_template_flag_interactive_message) {
    //     return (
    //         <li {...props} key={option.contact_tag_id} style={{ backgroundColor: messageTemplateDetail?.whatsapp_template_id == option?.whatsapp_template_id ? "#F7E9FF" : "" }}>
    //             $ {option.whatsapp_template_data[0].whatsapp_template_name}
    //         </li>
    //     )
    // }
    return (
        <li
            {...props}
            key={key}
            style={{ ...style, display: "flex", alignItems: "flex-start", gap: "12px", flexWrap: "wrap" }}
        >
            {renderTemplateCategoryChip(option)}
            <span
                className={styles.templateOptionName}
            >
                {option?.whatsapp_template_data?.[0]?.whatsapp_template_display_name ?? option?.whatsapp_template_data?.[0]?.whatsapp_template_name}
            </span>
        </li>
    )
}

export const getWabaName = (integrationListNewStructure, WabaId) => {
    let waba_name = "Whatsapp";
    if (integrationListNewStructure) {
        const obj = integrationListNewStructure.find((list
            // : metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew
        ) => list.integrated_channel_id == Number(WabaId));
        if (obj) {
            if ("waba_name" in obj) {
                waba_name = obj.waba_name;
            }
        }
    }
    return waba_name;
} 

export const isVisitWebsiteBtn = (btnName) => {
    if(btnName?.toLowerCase() == "visit website") return true;
    return false;
} 

export const isCustomBtn = (btnName) => {
    if(btnName?.toLowerCase() == "custom") return true;
    return false;
} 

export const getSubBtnNameFromGenericData = (whatsappTemplateButtonGenericData, whatsapp_template_button_type_id, whatsapp_template_button_sub_type_id) => {  
    return whatsappTemplateButtonGenericData?.find((btn) => btn.whatsapp_template_button_type_id == whatsapp_template_button_type_id)?.whatsapp_template_button_sub_type_data?.find((subType) => subType.whatsapp_template_button_sub_type_id == whatsapp_template_button_sub_type_id)?.whatsapp_template_button_sub_type_name || "";
}

export const getDefaultValueOfFlagAllowTracking = (btnName, templateType) => { 
    if(templateType?.toLowerCase() == "carousel"){
        return false;
    }
    return isVisitWebsiteBtn(btnName);
}

export const getInteractiveTypeName = (interactive_type_id, interactiveTypeList) => {
    const interactiveType = interactiveTypeList?.find((type) => type?.interactive_type_id == interactive_type_id);
    if(interactiveType){
        return formatString(interactiveType?.interactive_type_name);
    }
    return "";
} 

export const INTERACTIVE_TEMPLATE_TYPE = {
    LIST: "list",
    TEXT: "text",
    FLOW: "flow",
    CTA_URL: "cta url",
    REPLY_BUTTONS: "reply buttons",
    ORDER_DETAILS: "order details",
    CATALOG_MESSAGE: "catalog message",
    REQUEST_CONTACT_INFO: "request contact info"
}

export const isInteractiveTypeMessageOrderDetails = (interactive_type_id, interactiveTypeList) => {
    return getInteractiveTypeName(interactive_type_id, interactiveTypeList)?.toLowerCase() == INTERACTIVE_TEMPLATE_TYPE["ORDER_DETAILS"];
} 

export const isInteractiveTypeMessageList = (interactive_type_id, interactiveTypeList) => {
    return getInteractiveTypeName(interactive_type_id, interactiveTypeList)?.toLowerCase() == INTERACTIVE_TEMPLATE_TYPE["LIST"];
} 

export const isInteractiveTypeMessageFlow = (interactive_type_id, interactiveTypeList) => {
    return getInteractiveTypeName(interactive_type_id, interactiveTypeList)?.toLowerCase() == INTERACTIVE_TEMPLATE_TYPE["FLOW"];
}

export const isInteractiveTypeMessageCtaUrl = (interactive_type_id, interactiveTypeList) => {
    return getInteractiveTypeName(interactive_type_id, interactiveTypeList)?.toLowerCase() == INTERACTIVE_TEMPLATE_TYPE["CTA_URL"];
}

export const isInteractiveTypeMessageRequestContactInfo = (interactive_type_id, interactiveTypeList) => {
    return getInteractiveTypeName(interactive_type_id, interactiveTypeList)?.toLowerCase() === INTERACTIVE_TEMPLATE_TYPE["REQUEST_CONTACT_INFO"];
}

export const isInteractiveTypeNameOrderDetails = (interactive_type_name) => {
    return (formatString(interactive_type_name ?? ""))?.toLowerCase() == INTERACTIVE_TEMPLATE_TYPE["ORDER_DETAILS"];
}

export const getTemplateInteractiveMeta = (templatePayload) => ({
    interactiveTypeId: templatePayload?.interactive_type_id ?? templatePayload?.interactive_type?.interactive_type_id ?? null,
    interactiveTypeName: templatePayload?.interactive_type_name ?? templatePayload?.interactive_type?.interactive_type_name ?? null,
});

export const isOrderDetailsInteractiveTemplate = (templatePayload, interactiveTypeList) => {
    const { interactiveTypeId, interactiveTypeName } = getTemplateInteractiveMeta(templatePayload);
    return isInteractiveTypeMessageOrderDetails(interactiveTypeId, interactiveTypeList ?? []) || isInteractiveTypeNameOrderDetails(interactiveTypeName ?? "");
};

export const isInteractiveTemplateTypeList = (templatePayload, interactiveTypeList) => {
    const { interactiveTypeId, interactiveTypeName } = getTemplateInteractiveMeta(templatePayload);
    return isInteractiveTypeMessageList(interactiveTypeId, interactiveTypeList ?? []) || isInteractiveTypeNameList(interactiveTypeName ?? "");
};

export const shouldShowWhatsAppTemplateButtonsPreview = (templatePayload, interactiveTypeList, buttonsCount = 0, whatsappTemplateTypes = []) => {
    if (Number(buttonsCount) > 0) {
        return true;
    }
    return isOrderDetailsInteractiveTemplate(templatePayload, interactiveTypeList) || isCallPermissionRequestTemplate(whatsappTemplateTypes, templatePayload?.whatsapp_template_type_id);
};

export const isInteractiveTypeNameList = (interactive_type_name) => {
    return (formatString(interactive_type_name ?? ""))?.toLowerCase() === INTERACTIVE_TEMPLATE_TYPE["LIST"];
}

export const isInteractiveTypeNameCatalogMessage = (interactive_type_name) => {
    return (formatString(interactive_type_name ?? ""))?.toLowerCase() === INTERACTIVE_TEMPLATE_TYPE["CATALOG_MESSAGE"];
}

export const isInteractiveTypeNameText = (interactive_type_name) => {
    return (formatString(interactive_type_name ?? ""))?.toLowerCase() === INTERACTIVE_TEMPLATE_TYPE["TEXT"];
}

export const isInteractiveTypeNameRequestContactInfo = (interactive_type_name) => {
    return (formatString(interactive_type_name ?? ""))?.toLowerCase() === INTERACTIVE_TEMPLATE_TYPE["REQUEST_CONTACT_INFO"];
}

export const getValidationsFromInteractiveType = (interactive_type_id, interactiveTypeList) => {
    const selectedInteractiveType = getInteractiveTypeName(interactive_type_id, interactiveTypeList)?.toLowerCase();
    switch(selectedInteractiveType){
        case INTERACTIVE_TEMPLATE_TYPE["LIST"]: 
            return {
                maximum_button_count: 10,
                minimum_button_count: 1,
                allowed_header_type: ["none", "text"],
                button_text_character_limit: 24,
                header_text_character_limit: 60,
                body_text_character_limit: 4096,
                footer_text_character_limit: 60, 
                show_btn_description_field: true,
                btn_description_character_limit: 72,
            }
        case INTERACTIVE_TEMPLATE_TYPE["TEXT"]: 
            return {
                maximum_button_count: 0,
                minimum_button_count: 0,
                allowed_header_type: ["none"],
                button_text_character_limit: 24,
                header_text_character_limit: 60,
                body_text_character_limit: 4096,
                footer_text_character_limit: 0, 
                show_btn_description_field: false,
                btn_description_character_limit: 72,
            }
        case INTERACTIVE_TEMPLATE_TYPE["FLOW"]: 
            return {
                maximum_button_count: 1,
                minimum_button_count: 1,
                allowed_header_type: ["none", "text", "image", "video", "document"],
                button_text_character_limit: 20,
                header_text_character_limit: 60,
                body_text_character_limit: 4096,
                footer_text_character_limit: 60, 
                show_btn_description_field: false,
                btn_description_character_limit: 0,
            }
        case INTERACTIVE_TEMPLATE_TYPE["CTA_URL"]:
            return {
                maximum_button_count: 1,
                minimum_button_count: 1,
                allowed_header_type: ["none", "text", "image", "video", "document"],
                button_text_character_limit: 20,
                header_text_character_limit: 60,
                body_text_character_limit: 1024,
                footer_text_character_limit: 60,
                show_btn_description_field: false,
                btn_description_character_limit: 0,
            }
        case INTERACTIVE_TEMPLATE_TYPE["REPLY_BUTTONS"]:
            return {
                maximum_button_count: 3,
                minimum_button_count: 1,
                allowed_header_type: ["none", "text", "image", "video", "document"],
                button_text_character_limit: 20,
                header_text_character_limit: 60,
                body_text_character_limit: 1024,
                footer_text_character_limit: 60,
                show_btn_description_field: false,
                btn_description_character_limit: 0,
            }
        case INTERACTIVE_TEMPLATE_TYPE["ORDER_DETAILS"]:
            return {
                maximum_button_count: 0,
                minimum_button_count: 0,
                allowed_header_type: ["none"],
                button_text_character_limit: 0,
                header_text_character_limit: 60,
                body_text_character_limit: 1024,
                footer_text_character_limit: 60,
                show_btn_description_field: false,
                btn_description_character_limit: 0,
            }
        case INTERACTIVE_TEMPLATE_TYPE["CATALOG_MESSAGE"]:
            return {
                maximum_button_count: 1,
                minimum_button_count: 1,
                allowed_header_type: ["none"],
                button_text_character_limit: 25,
                header_text_character_limit: 0,
                body_text_character_limit: 1024,
                footer_text_character_limit: 60,
                show_btn_description_field: false,
                btn_description_character_limit: 0,
            }
        case INTERACTIVE_TEMPLATE_TYPE["REQUEST_CONTACT_INFO"]:
            return {
                maximum_button_count: 1,
                minimum_button_count: 1,
                allowed_header_type: ["none"],
                button_text_character_limit: 18,
                header_text_character_limit: 60,
                body_text_character_limit: 1024,
                footer_text_character_limit: 0,
                show_btn_description_field: false,
                btn_description_character_limit: 0,
            }
        default:
            return {
                maximum_button_count: 10,
                minimum_button_count: 0,
                button_text_character_limit: 25,
                allowed_header_type: [],
                header_text_character_limit: 60,
                body_text_character_limit: 1024,
                footer_text_character_limit: 60,
                show_btn_description_field: false,
                btn_description_character_limit: 0,
            }
    }
}

export const getTotalButtonsForBasicTemplate = (createTemplatePayload) => {
    return createTemplatePayload?.whatsapp_template_data?.whatsapp_template_button?.reduce((acc, item) => {
        return acc + (item?.whatsapp_template_button_data?.length ?? 0);
    }, 0);
} 

export const getButtonTooltipTextForInteractiveMessage = (createTemplatePayload, interactiveTypeList) => {
    const selectedInteractiveType = getInteractiveTypeName(createTemplatePayload?.interactive_type_id, interactiveTypeList); 
    if(isInteractiveTypeMessageOrderDetails(createTemplatePayload?.interactive_type_id, interactiveTypeList)){
        return 'For the Order Details Interactive message type, WhatsApp automatically includes the "Review and Pay" button. Custom buttons are not allowed in this template.'
    } else {
        const totalButtons = getTotalButtonsForBasicTemplate(createTemplatePayload); 
        const minimumBtnCount = getValidationsFromInteractiveType(createTemplatePayload?.interactive_type_id, interactiveTypeList)?.minimum_button_count;
        const maximumBtnCount = getValidationsFromInteractiveType(createTemplatePayload?.interactive_type_id, interactiveTypeList)?.maximum_button_count;
        if(totalButtons < minimumBtnCount){
            return `At least ${minimumBtnCount} ${minimumBtnCount === 1 ? `${isInteractiveTypeMessageList(createTemplatePayload?.interactive_type_id, interactiveTypeList) ? "row" : "button"} is` : `${isInteractiveTypeMessageList(createTemplatePayload?.interactive_type_id, interactiveTypeList) ? "rows" : "buttons"} are`} required for "${selectedInteractiveType}" interactive message type.`;
        } else {
            return `Maximum ${maximumBtnCount} ${maximumBtnCount === 1 ? `${isInteractiveTypeMessageList(createTemplatePayload?.interactive_type_id, interactiveTypeList) ? "row" : "button"} is` : `${isInteractiveTypeMessageList(createTemplatePayload?.interactive_type_id, interactiveTypeList) ? "rows" : "buttons"} are`} allowed for "${selectedInteractiveType}" interactive message type.`;
        }
    }
}

export const dynamicUrlVisitWebsiteBtnTooltipText = () => {
    return (
        <div>
            <h3>Dynamic URL Variable Rules</h3>

            <p>
                Adding a variable creates a personalized link for the customer to view their information.
                To ensure this works correctly, the following rules must be strictly followed:
            </p>

            <ul>
                <li>Exactly one variable is mandatory in the URL.</li>
                <li>
                    The variable must be written only as <code>{'{{1}}'}</code> — no other formats are allowed
                    (e.g., <code>{'{{name}}'}</code>, <code>{'{{2}}'}</code> are invalid).
                </li>
                <li>The variable must be placed at the very end of the URL and cannot be included as a query parameter.</li>
            </ul>

            <p><strong>Example (valid):</strong></p>
            <ul>
                <li><code>https://example.com/{'{{1}}'}</code></li>
            </ul>

            <p><strong>Examples (invalid):</strong></p>
            <ul>
                <li><code>https://example.com/{'{{name}}'}</code></li>
                <li><code>https://example.com/{'{{2}}'}</code></li>
                <li><code>https://example.com/page?user={'{{1}}'}</code></li>
            </ul>
        </div>
    );
};

export const getTextCharacterLimit = (createTemplatePayload, interactiveTypeList, type) => {

    const validations = getValidationsFromInteractiveType(createTemplatePayload?.interactive_type_id, interactiveTypeList);
    switch(type?.toLowerCase()){
        case "footer text limit": 
            if(createTemplatePayload?.whatsapp_template_flag_interactive_message){
                return validations?.footer_text_character_limit;
            } else {
                return maxFooterChars;
            }
        case "header text limit":
            if(createTemplatePayload?.whatsapp_template_flag_interactive_message){
                return validations?.header_text_character_limit;
            } else {
                return maxHeaderTextChars;
            }
        case "body text limit": 
            if(createTemplatePayload?.whatsapp_template_flag_interactive_message){
                return validations?.body_text_character_limit;
            } else {
                return maxChars;
            }
    }
}

export const needToShowInteractiveButtons = (createTemplatePayload, interactiveTypeList, whatsappTemplateTypes) => {
    if(createTemplatePayload?.whatsapp_template_flag_interactive_message && getValidationsFromInteractiveType(createTemplatePayload?.interactive_type_id, interactiveTypeList)?.minimum_button_count == 0){
        return false;
    }

    if(isCallPermissionRequestTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id)){
        return false;
    }

    return true;
}

export const needToShowHeader = (createTemplatePayload, interactiveTypeList, whatsappTemplateTypes, templateLibraryCategoryList) => {
    if(createTemplatePayload?.whatsapp_template_flag_interactive_message && getValidationsFromInteractiveType(createTemplatePayload?.interactive_type_id, interactiveTypeList)?.allowed_header_type?.includes("none") && getValidationsFromInteractiveType(createTemplatePayload?.interactive_type_id, interactiveTypeList)?.allowed_header_type?.length == 1){
        return false;
    }
    if(hasShareContactInfoButton(createTemplatePayload)){
        return false;
    }
    if(isCatalogTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id)){
        return false;
    }
    if(isInteractiveTypeNameCatalogMessage(getInteractiveTypeName(createTemplatePayload?.interactive_type_id, interactiveTypeList))){
        return false;
    }
    if(isTemplateCategoryAuthentication(templateLibraryCategoryList, createTemplatePayload?.whatsapp_template_data?.whatsapp_template_category_id)) {
        return false;
    }

    return true;
}

export const needToShowTypeOfVariable = (createTemplatePayload, templateLibraryCategoryList) => {
    if(isTemplateCategoryAuthentication(templateLibraryCategoryList, createTemplatePayload?.whatsapp_template_data?.whatsapp_template_category_id)) {
        return false;
    }
    return true;
}

export const TEMPLATE_TYPES = {
    BASIC: "Basic",
    FLOW: "Flow",
    CAROUSEL: "Carousel",
    CALL_PERMISSION_REQUEST: "Call Permission Request",
    CATALOG: "Catalog"
}

export const BTN_TYPE_NAMES = {
    QUICK_REPLY: 'Quick reply',
    CALL_TO_ACTION: 'Call to action',
    FLOW: 'Flow',
    COPY_CODE: 'Copy Code',
    ORDER_DETAILS: 'ORDER_DETAILS',
    CATALOG: 'Catalog',
    REQUEST_CONTACT_INFO: 'Request Contact Info'
}

export const BTN_SUB_TYPE_NAMES = {
    MARKETING_OPT_OUT: 'Marketing opt-out',
    CUSTOM: 'Custom',
    VISIT_WEBSITE: 'Visit Website',
    CALL_PHONE_NUMBER: 'Call phone number',
    COMPLETE_FLOW: 'Complete Flow',
    COPY_OFFER_CODE: 'Copy offer code',
    OPEN_FORM: 'Open Form',
    COPY_CODE: 'Copy Code',
    REVIEW_AND_PAY: 'Review and Pay',
    VIEW_CATALOG: 'View Catalog',
    SHARE_CONTACT_INFO: 'Share Contact Info'
}

export const isTemplateTypeFlow = (name) => {
    return name?.toLowerCase() === TEMPLATE_TYPES["FLOW"].toLowerCase();
}

export const isTemplateTypeCallPermissionRequest = (name) => {
    return name?.toLowerCase() === TEMPLATE_TYPES["CALL_PERMISSION_REQUEST"].toLowerCase();
}

export const isTemplateTypeCarousel = (name) => {
    return name?.toLowerCase() === TEMPLATE_TYPES["CAROUSEL"].toLowerCase();
}

const getFlattenedTemplateButtonData = (createTemplatePayload, flagCarousel = false) => {
    if (flagCarousel) {
        return createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card?.[0]?.whatsapp_template_button?.flatMap((btn) => btn?.whatsapp_template_button_data) ?? [];
    }
    return createTemplatePayload?.whatsapp_template_data?.whatsapp_template_button?.flatMap((btn) => btn?.whatsapp_template_button_data) ?? [];
};

const isShareContactInfoButtonData = (btn) => {
    return btn?.whatsapp_template_button_sub_type_name?.toLowerCase() === BTN_SUB_TYPE_NAMES['SHARE_CONTACT_INFO']?.toLowerCase();
}

export const hasShareContactInfoButton = (createTemplatePayload, flagCarousel = false) => {
    return getFlattenedTemplateButtonData(createTemplatePayload, flagCarousel).some(isShareContactInfoButtonData);
};

export const maximumAllowedButtons = (btnSubTypeName, createTemplatePayload, interactiveTypeList) => {
    let maximumAllowedButtonCount = 0;

    const shareContactInfoName = BTN_SUB_TYPE_NAMES['SHARE_CONTACT_INFO']?.toLowerCase();
    const templateButtons = getFlattenedTemplateButtonData(createTemplatePayload);
    const hasShareContactInfo = hasShareContactInfoButton(createTemplatePayload);
    const hasOtherButtons = templateButtons.some((btn) => !isShareContactInfoButtonData(btn));

    if ((btnSubTypeName === shareContactInfoName && hasOtherButtons) || (btnSubTypeName !== shareContactInfoName && hasShareContactInfo)) {
        return 0;
    }

    switch(btnSubTypeName){
        // case 1:  // Marketing opt-out
        case BTN_SUB_TYPE_NAMES['MARKETING_OPT_OUT']?.toLowerCase():
            maximumAllowedButtonCount = 1;
            break;
        
        // case 3: //view website
        case BTN_SUB_TYPE_NAMES['VISIT_WEBSITE']?.toLowerCase():
            if(isInteractiveTypeMessageCtaUrl(createTemplatePayload?.interactive_type_id, interactiveTypeList)){
                maximumAllowedButtonCount = 1;
            } else {
                if(createTemplatePayload?.whatsapp_template_flag_interactive_message) maximumAllowedButtonCount = 0;
                else maximumAllowedButtonCount = 2;
            }
            break;
        
        // case 7: // Flow Button
        case BTN_SUB_TYPE_NAMES['OPEN_FORM']?.toLowerCase():
            if(isInteractiveTypeMessageFlow(createTemplatePayload?.interactive_type_id, interactiveTypeList)){
                maximumAllowedButtonCount = 1;
            } else {
                if(createTemplatePayload?.whatsapp_template_flag_interactive_message) maximumAllowedButtonCount = 0;
                else maximumAllowedButtonCount = 1;
            }
            break;
        
        // case 10: // Share Contact Info
        case BTN_SUB_TYPE_NAMES['SHARE_CONTACT_INFO']?.toLowerCase():
            if(isInteractiveTypeMessageRequestContactInfo(createTemplatePayload?.interactive_type_id, interactiveTypeList)){
                maximumAllowedButtonCount = 1;
            } else {
                if(createTemplatePayload?.whatsapp_template_flag_interactive_message) maximumAllowedButtonCount = 0;
                else maximumAllowedButtonCount = 1;
            }
            break;  
        
        case BTN_SUB_TYPE_NAMES['COPY_CODE']?.toLowerCase():
        case BTN_SUB_TYPE_NAMES['REVIEW_AND_PAY']?.toLowerCase():
        case BTN_SUB_TYPE_NAMES['VIEW_CATALOG']?.toLowerCase():
            break;
        
        // case BTN_SUB_TYPE_NAMES
        default: 
            if(createTemplatePayload?.whatsapp_template_flag_interactive_message){
                maximumAllowedButtonCount = 0;
            } else {
                maximumAllowedButtonCount = 1;
            }
    }

    return maximumAllowedButtonCount;
}

// Button display utility functions for template previews
export const hasTemplateButtons = (metaInformation) => {
    return metaInformation?.whatsapp_template_data?.whatsapp_template_button?.length > 0;
}

export const getAllTemplateButtons = (metaInformation) => {
    return metaInformation?.whatsapp_template_data?.whatsapp_template_button?.flatMap((btn) => btn?.whatsapp_template_button_data) || [];
}

export const getButtonCount = (metaInformation) => {
    return getAllTemplateButtons(metaInformation).length;
}

export const shouldShowLimitedButtons = (metaInformation, interactiveTypeList) => {
    return !isInteractiveTypeMessageList(metaInformation?.interactive_type_id, interactiveTypeList ?? []) &&
           hasTemplateButtons(metaInformation) &&
           getButtonCount(metaInformation) <= 3;
}

export const shouldShowLimitedButtonsSlice = (metaInformation, interactiveTypeList) => {
    return !isInteractiveTypeMessageList(metaInformation?.interactive_type_id, interactiveTypeList ?? []) &&
           hasTemplateButtons(metaInformation) &&
           getButtonCount(metaInformation) > 3;
}

export const shouldShowAllOptionsButton = (metaInformation, interactiveTypeList) => {
    return isInteractiveTemplateTypeList(metaInformation, interactiveTypeList) || getButtonCount(metaInformation) > 3;
}

export const shouldShowDrawerButtons = (metaInformation) => {
    return hasTemplateButtons(metaInformation);
}

export const WHATSAPP_TEMPLATE_STATUS = {
    APPROVED: 'Approved',
    REJECTED: 'Rejected',
    PENDING: 'Pending' 
}

export const TEMPLATE_QUALITY_RATING = {
    GREEN: "GREEN",
    YELLOW: "YELLOW",
    RED: "RED",
    UNKNOWN: "UNKNOWN"
}

export const getTemplateQualityRating = (score) => {
    if(score){
        switch(score){
            case TEMPLATE_QUALITY_RATING["GREEN"]:
                return "High";
            case TEMPLATE_QUALITY_RATING["YELLOW"]:
                return "Medium";
            case TEMPLATE_QUALITY_RATING["RED"]:
                return "Low";
            case TEMPLATE_QUALITY_RATING["UNKNOWN"]:
                return "Unknown";
        }
    }
    return getValueOrDefault(score);
}
export const TEMPLATE_BUTTON_FIELDS = {
    BUTTON_TEXT: 'Button Text',
    PAYLOAD: 'Payload',
    BUTTON_DESCRIPTION: 'Button Description',
    URL_TYPE: 'URL Type',
    WEBSITE_URL: 'Website URL',
    COUNTRY: 'Country',
    PHONE_NUMBER: 'Phone number',
    OFFER_CODE: 'Offer Code',
    FLOW: 'Flow',
    FLOW_PAYLOAD_OBJECT: 'Flow Payload Object',
    FLOW_INPUT_PAYLOAD: 'Flow Input Payload'
}

export const getTemplateTypeName = (whatsappTemplateTypes, whatsapp_template_type_id) => {
    const templateType = whatsappTemplateTypes?.find((types) => types?.whatsapp_template_type_id == whatsapp_template_type_id); 
    if(templateType){
        return templateType?.name?.toLowerCase();
    } 
    return "";
}

export const isTemplateType = (whatsappTemplateTypes, whatsapp_template_type_id, templateType) => {
    const templateTypeName = getTemplateTypeName(whatsappTemplateTypes, whatsapp_template_type_id);
    
    return templateTypeName?.toLowerCase() === templateType?.toLowerCase();
}

export const isBasicTemplate = (whatsappTemplateTypes, whatsapp_template_type_id) => isTemplateType(whatsappTemplateTypes, whatsapp_template_type_id, TEMPLATE_TYPES['BASIC']);

export const isCarouselTemplate = (whatsappTemplateTypes, whatsapp_template_type_id) => isTemplateType(whatsappTemplateTypes, whatsapp_template_type_id, TEMPLATE_TYPES['CAROUSEL']);

export const isCatalogTemplate = (whatsappTemplateTypes, whatsapp_template_type_id) => isTemplateType(whatsappTemplateTypes, whatsapp_template_type_id, TEMPLATE_TYPES['CATALOG']);

export const isCallPermissionRequestTemplate = (whatsappTemplateTypes, whatsapp_template_type_id) => isTemplateType(whatsappTemplateTypes, whatsapp_template_type_id, TEMPLATE_TYPES['CALL_PERMISSION_REQUEST']);

export const isInteractiveCatalogTemplate = (interactiveTypeList, interactive_type_id) => {
    return isInteractiveTypeNameCatalogMessage(getInteractiveTypeName(interactive_type_id, interactiveTypeList));
}

export const isInteractiveTypeText = (interactiveTypeList, interactive_type_id) => {
    return isInteractiveTypeNameText(getInteractiveTypeName(interactive_type_id, interactiveTypeList));
}

export const TEMPLATE_STATUS_TYPE = {
    APPROVED: "Approved",
    PENDING: "Pending",
    REJECTED: "Rejected"
}

export const isTemplateStatus = (status, checkStatus) => {
    return status?.toLowerCase() == checkStatus?.toLowerCase();
}

export const canUpdateTemplate = (status, createTemplatePayload, whatsappTemplateTypes, draftId) => {
    // return !status || status?.length === 0 || isTemplateStatusApproved(status) || isInteractiveTemplate || Boolean(draftId);

    const isInteractiveTemplate = createTemplatePayload?.whatsapp_template_flag_interactive_message;
    const templateId = createTemplatePayload?.whatsapp_template_id;
    const templateTypeId = createTemplatePayload?.whatsapp_template_type_id;

    if(templateId && (isCatalogTemplate(whatsappTemplateTypes, templateTypeId))){
        return false;
    } else if(!isTemplateStatus(status, TEMPLATE_STATUS_TYPE['PENDING']) && !isTemplateStatus(status, TEMPLATE_STATUS_TYPE['REJECTED'])){
        return true;
    } else if(isInteractiveTemplate || Boolean(draftId)){
        return true;
    }

    return false;
}

export const canUpdateTemplateFooter = (status, createTemplatePayload, whatsappTemplateTypes, draftId, existingTemplateData, templateId) => {
    // const isInteractiveTemplate = createTemplatePayload?.whatsapp_template_flag_interactive_message;
    if(canUpdateTemplate(status, createTemplatePayload, whatsappTemplateTypes, draftId) && ((existingTemplateData?.whatsapp_template_data?.whatsapp_template_footer?.whatsapp_template_footer_value?.length > 0) || !templateId)){
        return true;
    }
    return false;
}

export const shouldShowTemplateFooter = (createTemplatePayload, interactiveTypeList, existingTemplateData) => {
    const charLimit = getTextCharacterLimit(createTemplatePayload, interactiveTypeList, "footer text limit") ?? maxFooterChars;
    if (charLimit <= 0) return false;

    if (hasShareContactInfoButton(createTemplatePayload)) {
        return false;
    }

    if (!createTemplatePayload?.whatsapp_template_id) return true;

    const existingFooterValue = existingTemplateData?.whatsapp_template_data?.whatsapp_template_footer?.whatsapp_template_footer_value;
    const currentFooterValue = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_footer?.whatsapp_template_footer_value;

    return Boolean(existingFooterValue?.length > 0 || currentFooterValue?.length > 0);
}

export const TEMPLATE_CATEGORY = {
    MARKETING: "Marketing",
    UTILITY: "Utility",
    AUTHENTICATION: "Authentication"
}

export const TYPE_OF_VARIABLE = {
    NUMBER: 'Number',
    NAME: 'Name'
}
export const TYPE_OF_VARIABLE_OPTIONS = [TYPE_OF_VARIABLE['NUMBER'], TYPE_OF_VARIABLE['NAME']];

export const getTooltipTextOfTypeOfVariable = () => {
    return (
        <div>
            <h3>Type of variable</h3>

            <p>
                Variables are placeholders that are used to dynamically insert specific
                information or data into your template. You can insert either a name or
                number as a variable.
            </p>

            <p><strong>Examples:</strong></p>

            <ul>
                <li>Name: <code>{'{{order_id}}'}</code></li>
                <li>Number: <code>{'{{1}}'}</code></li>
            </ul>
        </div>
    );
}

export const validateVariableKeys = (variableData, flagNamedParams) => {
    const regex = flagNamedParams ? VALIDATE_VARIABLE_REGEX['FLAG_NAME'] : VALIDATE_VARIABLE_REGEX['FLAG_NUMBER'];

    if(variableData && variableData?.length > 0){
        for(const variable of variableData){
            const variableKey = variable?.whatsapp_template_dynamic_variable_key;
    
            const match = variableKey?.match(/^{{(.+?)}}$/);
            if(!match) return false;
    
            const varValue = match[1];
    
            if(!regex.test(varValue)){
                return false;
            }
        }
    }
    return true;
}

export const areTemplateVariablesModified = (existingVariableData, updatedVariableData) => {
    if(existingVariableData?.length != updatedVariableData?.length){
        return true;
    }

    for(let i = 0; i < existingVariableData?.length; i++){
        const existingVariable = existingVariableData[i];
        const updatedVariable = updatedVariableData[i];

        if(existingVariable?.whatsapp_template_dynamic_variable_id !== updatedVariable?.whatsapp_template_dynamic_variable_id || existingVariable?.whatsapp_template_dynamic_variable_key !== updatedVariable?.whatsapp_template_dynamic_variable_key){
            return true;
        }
    }

    return false;
}

export const areHeaderVariablesModified = (createTemplatePayload, existingTemplateData) => {
    if(!createTemplatePayload?.whatsapp_template_id){
        return false;
    }
    const existingHeaderVariableData = existingTemplateData?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_variable_data ?? [];
    const updatedHeaderVariableData = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_variable_data ?? [];

    return areTemplateVariablesModified(existingHeaderVariableData, updatedHeaderVariableData);
}

export const areBodyVariablesModified = (createTemplatePayload, existingTemplateData) => {
    if(!createTemplatePayload?.whatsapp_template_id){
        return false;
    }
    const existingBodyVariableData = existingTemplateData?.whatsapp_template_data?.whatsapp_template_body?.whatsapp_template_body_variable_data ?? [];
    const updatedBodyVariableData = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_body?.whatsapp_template_body_variable_data ?? [];

    return areTemplateVariablesModified(existingBodyVariableData, updatedBodyVariableData);
}

export const doesTextStartOrEndWithVariable = (text, flagNamedParam) => {
    const trimmed = (text ?? '').trim();
    if (!trimmed) {
        return false;
    }

    const regexKey = flagNamedParam ? 'FLAG_NAME' : 'FLAG_NUMBER';
    const { START, END } = BODY_VARIABLE_AT_EDGE_REGEX[regexKey];

    return START.test(trimmed) || END.test(trimmed);
}

export const doesBodyTextStartOrEndWithVariable = (createTemplatePayload) => {
    const bodyText = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_body?.whatsapp_template_body_value;
    return doesTextStartOrEndWithVariable(bodyText, createTemplatePayload?.flag_named_parameter);
}

export const doesCarouselMessageBodyTextStartOrEndWithVariable = (createTemplatePayload) => {
    const carouselMessageBodyText = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_header;
    return doesTextStartOrEndWithVariable(carouselMessageBodyText, createTemplatePayload?.flag_named_parameter);
}

export const renderBodyVariableEdgeWarning = () => {
    return (
        <Grid container flexWrap={"nowrap"} gap={1} p={2} className={formStyles.tooManyVariableWarning}>
            <Grid item>
                <ReportProblemOutlinedIcon className={formStyles.variableDisclaimerIcon} />
            </Grid>
            <Grid item>
                <span className={formStyles.variableDisclaimerText}>
                    Variable can't be at the start or end of the template.
                </span>
            </Grid>
        </Grid>
    )
}

export const renderTooManyVariableParameterWarning = () => {
    return (
        <Grid item>
            <Grid container flexWrap={"nowrap"} gap={1} className={formStyles.tooManyVariableWarning}>
                <Grid item>
                    <ReportProblemOutlinedIcon className={formStyles.variableDisclaimerIcon} />
                </Grid>
                <Grid item>
                    <span className={formStyles.variableDisclaimerText}>
                        This template contains too many variable parameters relative to the message length. You need to decrease the number of variable parameters or increase the message length.
                    </span>
                </Grid>
            </Grid>
        </Grid>
    )
}

export const renderWarningOfModifiedVar = () => {
    return (
        <Grid item className={`${styles.marginTop15}`}>
            <Grid container flexWrap={"nowrap"} gap={1} p={2} className={formStyles.tooManyVariableWarning}>
                <Grid item>
                    <ReportProblemOutlinedIcon className={formStyles.variableDisclaimerIcon} />
                </Grid>
                <Grid item>
                    <span className={formStyles.variableDisclaimerText}>
                        Variables must remain unchanged in compliance with Meta guidelines. To continue with changes, please refresh the page.
                    </span>
                </Grid>
            </Grid>
        </Grid>
    )
}

export const renderInvalidVarParamWarning = (flagNamedParam) => {
    return (
        <Grid item>
            <Grid container flexWrap={"nowrap"} gap={1} p={2} className={formStyles.tooManyVariableWarning}>
                <Grid item>
                    <ReportProblemOutlinedIcon className={formStyles.variableDisclaimerIcon} />
                </Grid>
                <Grid item>
                    <span className={formStyles.variableDisclaimerText}>
                        {flagNamedParam ?
                            'Variable parameters must be lowercase characters and underscores (for example, {{order_id}}, {{customer_name}}).'
                            : 
                            'Variable parameters must be numbers with two sets of curly brackets (for example, {{1}}, {{2}}).'
                        }
                    </span>
                </Grid>
            </Grid>
        </Grid>
    );
}

export const displayFlexCursorPointerClassName = `${globalStyles.displayFlexStyle} ${globalStyles.clickable}`;

export const isTemplateCategoryAuthentication = (templateLibraryCategoryList, whatsappTemplateCategoryId) => {
    return whatsappTemplateCategoryId === getTemplateCategoryId(TEMPLATE_CATEGORY?.AUTHENTICATION, templateLibraryCategoryList);
}

export const isTemplateCategoryMarketing = (templateLibraryCategoryList, whatsappTemplateCategoryId) => {
    return whatsappTemplateCategoryId === getTemplateCategoryId(TEMPLATE_CATEGORY?.MARKETING, templateLibraryCategoryList);
}

export const getTemplateCategoryId = (categoryName, templateLibraryCategoryList = []) => {
    return templateLibraryCategoryList?.find((category) => category?.whatsapp_template_category_name?.toLowerCase() === categoryName?.toLowerCase())?.whatsapp_template_category_id ?? 0;
}

export const hasVisitWebsiteBtn = (metaInformation) => {
    return (metaInformation?.whatsapp_template_data?.[0]?.whatsapp_template_button?.some((btn) => btn?.whatsapp_template_button_data?.some((data) => data?.whatsapp_template_button_sub_type_name?.toLowerCase() === "visit website"))) ? true : false;
}

export const hasQuickReplyBtn = (metaInformation) => {
    return (metaInformation?.whatsapp_template_data?.[0]?.whatsapp_template_button?.some((btn) => btn?.whatsapp_template_button_type_name?.toLowerCase() === "quick reply" )) ? true : false;
}

export const hasVisitWebsiteBtnandTrackingEnabled = (metaInformation) => {  
    return (hasVisitWebsiteBtn(metaInformation) && metaInformation?.flag_allow_tracking) ? true : false;
}

export const TEMPLATE_NAME_MAX_CHARS_FOR_TOOLTIP = 45;

export const RENDER_SECURITY_RECOMMENDATION_APPEND_TEXT = "For your security, do not share this code.";

export const renderAuthenticationTemplateFooterText = (minutes) => {
    return `Expires in ${minutes} minutes.`;
}

export const shouldRenderBtnIcon = (templateDetails, btnSubTypeName) => {
    if(!(templateDetails?.whatsapp_template_flag_interactive_message) && btnSubTypeName !== BTN_SUB_TYPE_NAMES['VIEW_CATALOG']){
        return true;
    }
    return false;
}

export const filterBtnData = (whatsappTemplateButtonGenericData) => {
    const hiddenBtns = [BTN_TYPE_NAMES['COPY_CODE'], BTN_TYPE_NAMES['ORDER_DETAILS'], BTN_TYPE_NAMES['CATALOG']];
    return whatsappTemplateButtonGenericData?.filter((btn) => !hiddenBtns?.includes(btn?.whatsapp_template_button_type_name));
}

export const getTemplateVariableDatObj = (variableId, variableValue, variableGoogleStorageId, flagFlowVariable) => {
    return {
        variable_id: variableId,
        variable_value: variableValue,
        variable_google_storage_id: variableGoogleStorageId,
        flag_flow_variable: flagFlowVariable
    }
}

const getAllButtonVariableData = (button) => {
    return button?.flatMap(btn =>
        btn.whatsapp_template_button_data.flatMap(data =>
            data.whatsapp_template_button_sub_type_field_data.flatMap(field =>
                field.whatsapp_template_button_field_data_variable || []
            )
        )
    )
}

const pushTemplateVariableData = (variableData, variables, flagFlowVariable = false) => {
    if (!Array.isArray(variables)) return;

    variables.forEach((variable) => {
        if (flagFlowVariable) {
            variableData.push(
                getTemplateVariableDatObj(variable?.whatsapp_flow_variable_id, variable?.whatsapp_flow_variable_sample_value ?? '', null, true)
            );
            return;
        }

        variableData.push(
            getTemplateVariableDatObj(
                variable?.whatsapp_template_dynamic_variable_id,
                variable?.whatsapp_template_dynamic_variable_sample_value,
                null,
                false
            )
        );
    });
};

const appendHeaderVariableData = (variableData, templateData) => {
    const headerData = templateData?.whatsapp_template_header?.whatsapp_template_header_data?.[0];
    const headerVariables = Array.isArray(headerData?.whatsapp_template_header_variable_data)
        ? headerData.whatsapp_template_header_variable_data
        : [];
    const storageId = headerData?.whatsapp_template_header_data_google_storage_id ?? null;

    headerVariables.forEach((variable) => {
        variableData.push(
            getTemplateVariableDatObj(
                variable?.whatsapp_template_dynamic_variable_id,
                variable?.whatsapp_template_dynamic_variable_sample_value,
                storageId,
                false
            )
        );
    });
};

const appendTemplateDataVariables = (variableData, templateData) => {
    if (!templateData) return;

    appendHeaderVariableData(variableData, templateData);

    const bodyVariables = Array.isArray(templateData?.whatsapp_template_body?.whatsapp_template_body_variable_data)
        ? templateData.whatsapp_template_body.whatsapp_template_body_variable_data
        : [];
    pushTemplateVariableData(variableData, bodyVariables);

    if (templateData?.whatsapp_template_button?.length > 0) {
        pushTemplateVariableData(variableData, getAllButtonVariableData(templateData.whatsapp_template_button) || []);
    }
};

const getFlowInputVariables = (templateData) => {
    return templateData?.whatsapp_template_button?.find((btn) => btn?.whatsapp_template_button_type_name?.toLowerCase() == "flow")
        ?.whatsapp_template_button_data?.[0]?.whatsapp_flow_data?.whatsapp_flow_version_data?.find((version) => version?.whatsapp_flow_metadata_response?.whatsapp_flow_meta_status?.toLowerCase() == "published")
        ?.whatsapp_flow_variables?.filter((flowVar) => flowVar?.input_variable_flag) || [];
};

export const getTemplateVariableDataForSendTemplateCurl = (templateDetails) => {
    const variableData = [];
    const templateDataList = Array.isArray(templateDetails?.whatsapp_template_data)
        ? templateDetails.whatsapp_template_data
        : [];

    if (isTemplateTypeCarousel(templateDetails?.whatsapp_template_type?.name)) {
        pushTemplateVariableData(variableData, templateDetails?.whtatsapp_carousel_header_variable_data || []);
        templateDataList.forEach((card) => appendTemplateDataVariables(variableData, card));
    } else {
        const templateData = templateDataList[0];
        appendTemplateDataVariables(variableData, templateData);

        if (templateDetails?.whatsapp_template_flag_flow) {
            pushTemplateVariableData(variableData, getFlowInputVariables(templateData), true);
        }
    }

    return variableData;
}

export const getIntegrationChannelIdForCopyCurl = (integrationListNewStructure, whatsapp_meta_integration_id) => {
    const defaultText = "{{insert the integrated channel ID associated with the phone number}}";
    const phoneNumbers = integrationListNewStructure
        ?.find((integration) => isWhatsAppIntegration(integration) && String(integration?.meta_integration_whatsapp_id) === String(whatsapp_meta_integration_id))
        ?.meta_integration_phone_number_data ?? [];

    return phoneNumbers?.length === 1
        ? (phoneNumbers[0]?.integrated_channel_id ?? defaultText)
        : defaultText;
}